import {List, Create, Edit} from '../Components'

export default [
    {path: '/admin/backup', component: List, name: 'backup-list'},
    {path: '/admin/backup/:id/edit', component: Edit, name: 'backup-edit'},
    {path: '/admin/backup/create', component: Create, name: 'backup-create'},
]